import React from "react";
import cx from "clsx";
import styles from "./styles.module.scss";
import { useContext } from "../../context";
import { Loading } from "../../../../../../boxes/Loading/Loading";

export const Layout = ({ children }) => {
  const { layout, isLoading } = useContext();

  if (isLoading) {
    return <Loading center className={styles.loader} />;
  }

  return (
    <div
      className={cx(styles.root, {
        [styles.rootParamsCollapsed]: !layout.params.isOpen,
        [styles.rootPreviewFull]: layout.preview.isFullView,
      })}
    >
      {children}
    </div>
  );
};
